import { Routes } from '@angular/router';

import { authGuard } from './core/auth/auth.guard';

export const appRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.page').then((m) => m.LoginPage)
  },
  {
    path: '',
    canMatch: [authGuard],
    loadComponent: () =>
      import('./layout/dashboard-layout/dashboard-layout.component').then((m) => m.DashboardLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'overview' },
      { path: 'airports-overview', redirectTo: 'overview' },
      {
        path: 'overview',
        loadChildren: () => import('./features/overview/overview.routes').then((m) => m.OVERVIEW_ROUTES)
      },
      {
        path: 'establishments',
        loadChildren: () =>
          import('./features/establishments/establishments.routes').then((m) => m.ESTABLISHMENTS_ROUTES)
      },
      {
        path: 'centers',
        loadChildren: () => import('./features/centers/centers.routes').then((m) => m.CENTERS_ROUTES)
      },
      {
        path: 'analytics',
        loadChildren: () => import('./features/analytics/analytics.routes').then((m) => m.ANALYTICS_ROUTES)
      },
      {
        path: 'reports',
        loadChildren: () => import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES)
      },
      {
        path: 'user-management',
        loadChildren: () =>
          import('./features/user-management/user-management.routes').then((m) => m.USER_MANAGEMENT_ROUTES)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];

